// Ensure jQuery is global (in case other libs expect $)
import $ from "jquery";
window.$ = window.jQuery = $;

// Owl core + its CSS
import "owl.carousel";
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";

function initOwl() {
    const el = document.getElementById("reviews");
    if (!el || !$.fn || !$.fn.owlCarousel) return;

    const $el = $(el);
    if ($el.hasClass("owl-loaded")) {
        try { $el.trigger("refresh.owl.carousel"); } catch (e) {}
        return;
    }

    $el.owlCarousel({
        loop: false,
        margin: 16,
        nav: false,
        autoplay: true,
        autoplayTimeout: 4000,
        autoplaySpeed: 400,
        responsive: {
            0:    { items: 1 },
            600:  { items: 3 },
            1000: { items: 3 }
        }
    });
}

document.addEventListener("DOMContentLoaded", initOwl);
document.addEventListener("turbo:load", initOwl);